<template>
  <UserArea
    :user-types="['schoolAdmin']"
    :admin-can-always-see="true"
    class="sf-container"
  >
    <div v-if="school">
      <SchoolActivationForm
        v-if="step == 'activate'"
        :mode="mode"
        :default-data="currentPurchase"
        @success="
          refreshPuchase($event);
          setStep('confirm');
        "
      />
      <SchoolActivationConfirm
        v-else-if="step == 'confirm'"
        :mode="mode"
        :tax="tax"
        :school-reference="schoolReference"
        :activate-trial="activateTrial"
        :purchase-data="purchaseData"
        @modify="setStep('activate')"
        @paywithcard="setStep('payWithCard')"
      />
      <div v-else-if="step == 'payWithCard'">
        <h1>Pay with Credit Card</h1>
        <SagePay
          v-if="purchaseData"
          :mode="mode"
          :school-reference="schoolReference"
          :purchase-data="purchaseData"
          @modify="setStep('activate')"
        />
      </div>
    </div>
  </UserArea>
</template>

<script lang="ts">
import UserArea from "@/components/permission/UserArea.vue";
import SchoolActivationConfirm from "@/components/purchase/SchoolActivationConfirm.vue";
import SchoolActivationForm from "@/components/purchase/SchoolActivationForm.vue";
import {
  SfPurchaseType,
  SfSchool,
  SfStorePurchaseData,
  SfTax,
} from "@/types/generalTypes";
import { defineComponent, PropType } from "vue";
import SagePay from "@/components/purchase/SagePay.vue";
import apiCall from "@/func/net/apiCall";

export default defineComponent({
  components: {
    UserArea,
    SchoolActivationForm,
    SchoolActivationConfirm,
    SagePay,
  },
  props: {
    mode: { type: String as PropType<SfPurchaseType>, required: true },
  },
  data() {
    return {
      schoolReference: "",
      spellingClassCount: 0,
      mathsClassCount: 0,
      schoolRef: "",
      activateTrial: false,
      purchaseData: null as SfStorePurchaseData | null,
    };
  },
  computed: {
    step(): "activate" | "confirm" | "payWithCard" {
      const res = this.$route.query.step;
      switch (res) {
        case "confirm":
          return "confirm";
        case "payWithCard":
          return "payWithCard";
      }
      return "activate";
    },
    school(): SfSchool | null {
      return this.$currentUser.value?.school
        ? this.$currentUser.value.school
        : null;
    },
    currentPurchase() {
      return {
        spellingClassCount: this.spellingClassCount,
        mathsClassCount: this.mathsClassCount,
        schoolReference: this.schoolReference,
        activateTrial: this.activateTrial,
      };
    },
    tax(): SfTax | null {
      return this.school?.tax ? this.school.tax : null;
    },
    countryCode(): string {
      return this.school?.country_code ? this.school.country_code : "GB";
    },
  },
  mounted() {
    this.waitRouter();
  },
  methods: {
    async waitRouter() {
      await this.$router.isReady();
      if (this.$route.query.step && this.$route.query.step != "activate") {
        const q = { ...this.$route.query };
        delete q.step;
        this.$router.push({ path: this.$route.path, query: q });
      }
    },
    async refreshPuchase(data: {
      spellingClassCount: number;
      mathsClassCount: number;
      schoolReference: string;
      activateTrial: boolean;
    }) {
      this.spellingClassCount = data.spellingClassCount;
      this.mathsClassCount = data.mathsClassCount;
      this.schoolReference = data.schoolReference;
      this.activateTrial = data.activateTrial;
      const params = {
        spellingClassCount: this.spellingClassCount,
        mathsClassCount: this.mathsClassCount,
        kind: this.mode,
      };
      const resData = await apiCall("account/school-purchase-cost", params);
      if (resData.success) {
        this.purchaseData = resData.data as SfStorePurchaseData;
      }
    },
    setStep(step: string) {
      const q = { ...this.$route.query, step };
      this.$router.push({ path: this.$route.path, query: q });
    },
  },
});
</script>
